import { useMeasure } from 'react-use';

export const useItemToDisplay = () => {
  const [ref, { width }] = useMeasure<HTMLDivElement>();

  let itemToDisplay = 2;
  if (width < 320) {
    itemToDisplay = 1;
  }
  if (width > 500) {
    itemToDisplay = 3;
  }

  return { ref, itemToDisplay };
};
